require('front/components/SectionBadge/SectionBadge');
require('front/components/ViewCount/ViewCount');

require('./PostItem.less');
